import { Button, Modal } from 'components/latest-core';
import { useContext, useState } from 'react';
import { navigateTo } from 'utilities/Utils';
import PersuasionModal from './PersuasionModal';
import pushToGTM, { GTM_CATEGORIES } from 'utilities/gtm';
import { routes } from 'app/routes';
import { useCurrentHotel } from 'utilities/CustomHooks';
import { INSTAGRAM_VIBES } from 'shared_logic/property-vibe/constants';
import { HotelContext } from 'utilities/Context';

const PersuasionActionButton = props => {
  const { route, btnText, persuasion, dashboard, refreshData, rank } = props;
  const [hotelcode, { showListings }] = useCurrentHotel();
  const { showNewContentScore } = useContext(HotelContext) || {};
  const [openPopup, setOpenPopup] = useState(false);
  const roomTypeCode = persuasion?.id?.split('_')?.[1] || '';
  const { promo_code = '', identifier = '' } = persuasion?.data || {};
  let queryParam = '';
  let updatedPncRoute = '';
  if (
    persuasion.type === 'promotion' &&
    persuasion.sub_type === 'not_applied'
  ) {
    if (identifier === 'no_promotion_applied' || identifier === 'no_lmr') {
      updatedPncRoute = routes.businessBooster.pnc.lastMinute;
    } else if (identifier === 'no_early_bird') {
      updatedPncRoute = routes.businessBooster.pnc.earlyBird;
    }
  } else if (
    persuasion.type === 'inventory' &&
    persuasion.sub_type === 'sold_out' &&
    roomTypeCode
  ) {
    queryParam = `?roomTypeCode=${roomTypeCode}`;
  } else if (promo_code) {
    updatedPncRoute = routes.businessBooster.pnc.modify;
    queryParam = `?id=${promo_code}`;
  }
  if (route === '/property/content-score' && showNewContentScore) {
    updatedPncRoute = routes.property.newContentScore;
  }

  const updatedRoute = (updatedPncRoute || route) + queryParam;
  const type = persuasion?.data?.offer_type?.[0];
  const modalTitle = `${
    type ? type[0].toUpperCase() + type.slice(1) : 'Promotion/Coupon'
  } Expiring`;

  const onPersuasionBtnClick = () => {
    if (!route) return;
    const _type = persuasion.type;
    const title = persuasion.title;

    if (dashboard) {
      pushToGTM(
        GTM_CATEGORIES.DASHBOARD,
        'action_center',
        `click_${_type} | rank: ${rank} | ${title}`,
      );
    } else {
      pushToGTM(
        GTM_CATEGORIES.ACTION_DETAIL,
        'action_center_l2',
        `click_${_type} | rank: ${rank} | ${title}`,
      );
    }
    if (route === INSTAGRAM_VIBES) {
      if (showListings) {
        navigateTo(routes.listing.propertyVibe);
      } else {
        navigateTo(routes.property.vibe);
      }
      return;
    }

    if (route === 'popup') {
      setOpenPopup(true);
    } else if (
      showListings &&
      (persuasion.sub_type === 'missing' ||
        persuasion.sub_type === 'to_instant_book')
    ) {
      navigateTo(routes.listing.base);
    } else {
      navigateTo(updatedRoute);
    }
  };

  return (
    <div className="persuasion-action-btn">
      <div className="btn-container">
        {route ? (
          <Button
            variant="text"
            onClick={onPersuasionBtnClick}
            data-test-id="oc_persuasion-btn"
            className="text-size-14"
          >
            {btnText}
          </Button>
        ) : (
          btnText
        )}
      </div>

      {openPopup && (
        <Modal
          title={modalTitle}
          onClose={() => setOpenPopup(false)}
          hideFooter
        >
          <PersuasionModal
            persuasion={persuasion}
            onModalClose={() => setOpenPopup(false)}
            dashboard
            hotelcode={hotelcode}
            refreshData={refreshData}
          />
        </Modal>
      )}
    </div>
  );
};

export default PersuasionActionButton;
